
import {translate} from '@elements/translations';
import {ref, onMounted, defineComponent, watch} from 'vue';
import { useTicketStore } from '~vue/stores/TicketStore.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
    name: 'ModalFooter',
    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        stepViews: {
            type: Array,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        totalValue: {
            type: Number,
            required: false
        }
    },
    setup(props, {emit}) {
        const ticketStore = useTicketStore();
        const { step, validation, ticketConfigurations, ticketCounter, ticketPriceGroups } = storeToRefs(ticketStore);
        const { changeStep, total } = ticketStore;
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const onChangeStep = (step: number) => {
            if(step === props.stepViews.length) {
                emit('addToCart');
                changeStep(step);
            } else {
                changeStep(step);
            }
        }

        const goBack = () => {
            if(step.value > 0) {
                changeStep(step.value - 1);
            } else {
                emit('closeModal', true);
            }
        };

        const currentStepName = ref(props.stepViews[step.value]);


        watch(() => step.value, () => {
            currentStepName.value = props.stepViews[step.value];
        });

        const getFilteredTicketCounter = () => {
            let filteredTicketCounter;
            return filteredTicketCounter = ticketPriceGroups.value.filter((item: any) => {
                return ticketCounter.value && ticketCounter.value[item.id] > 0;
            });
        }

        return {
            translate,
            goBack,
            validation,
            currentStepName,
            ticketConfigurations,
            total,
            ticketCounter,
            ticketPriceGroups,
            isMobile,
            getFilteredTicketCounter,
            onChangeStep,
        };
    }
})
;
